import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FFB0F0\" d=\"m.607 9.6 4.301 2.256L9.38 9.684 5.036.868.606 9.6Z\"></path><path fill=\"#FFB0F0\" d=\"m1.16 10.662 3.62 1.875 4.129-2.002L4.95 18.24l-3.792-7.579Z\"></path><path fill=\"#7540EE\" d=\"M20.898 4.872H7.787l2.29 4.691-.34.7H22V5.975c0-.609-.494-1.103-1.102-1.103M8.8 12.184l-1.164 2.394h13.262c.608 0 1.102-.494 1.102-1.102v-1.292z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M.607.868H22v17.373H.607z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }